/*
 * File: cell-membership-status.ts
 * Created: 2026-01-19 15:35:00
 * Author: Val Liu <valuis0429@gmail.com>
 */

import { Component } from "vue-property-decorator";
import { BaseTableBodyCell } from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";

@Component
@UITag.setDefault({
    uiAlign: "left",
    uiSort: false,
    uiSearch: false,
})
export default class CellMembershipStatus extends BaseTableBodyCell {}
